import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { Button, Popover } from 'antd';
import { FaUserCircle } from "react-icons/fa";

interface ProfileMenuItem {
    label: string;
    icon: string;
    redirectTo: string;
}

interface ProfileDropdownProps {
    menuItems: Array<ProfileMenuItem>;
    profilePic?: string;
    username: string;
}

const ProfileDropdown = (props: ProfileDropdownProps) => {
    const profilePic = props.profilePic || null;
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

    /*
     * toggle profile-dropdown
     */
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const content = (
        <div>
        {(props.menuItems || []).map((item, i) => {
            return (
            <div key={i} style={{marginBottom:5}} className='sanjabMenuIcon'>
                {i === props.menuItems.length - 1 && <div className="dropdown-divider"></div>}
                <Link
                    to={item.redirectTo}
                    className="dropdown-item notify-item"
                    key={i + '-profile-menu'}>
                    <FeatherIcon icon={item.icon} className="icon-dual icon-xs ms-1" />
                    <span>{item.label}</span>
                </Link>
            </div>
            );
        })}
        </div>
    )

    return (
        <Popover placement="left" content={content} trigger="click" title={props.username}  overlayInnerStyle={{minWidth:250, marginBottom:10, marginRight:10, backgroundColor:'#fbf9f9'}}>

            {/* <Button  size='small' type='text'    icon={<FaUserCircle style={{ fontSize: '22',color:'white' }} />} /> */}
            <div className="sanjabRightsidebar">
                <FaUserCircle style={{ fontSize: 22, color: 'white' }} />
            </div>




        </Popover>
        // <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
        //     <Dropdown.Toggle
        //         id="dropdown-profile"
        //         as="a"
        //         onClick={toggleDropdown}
        //         className={classNames('nav-link', 'nav-user', 'me-0', 'cursor-pointer', { show: dropdownOpen })}>
        //             <span className="pro-user-name ms-2">
        //             <i className="uil uil-angle-down"></i>
        //             {/* {props.username}  */}
        //         </span>
        //         <img src={profilePic!} className="rounded-circle" alt="" />

        //     </Dropdown.Toggle>
        //     <Dropdown.Menu className="dropdown-menu-end profile-dropdown">
        //         <div onClick={toggleDropdown}>
        //             {/* <div className="dropdown-header noti-title">
        //                 <h6 className="text-overflow m-0">داشبورد مدیریت سی جاب</h6>
        //             </div> */}
        //             {(props.menuItems || []).map((item, i) => {
        //                 return (
        //                     <React.Fragment key={i}>
        //                         {i === props.menuItems.length - 1 && <div className="dropdown-divider"></div>}
        //                         <Link
        //                             to={item.redirectTo}
        //                             className="dropdown-item notify-item"
        //                             key={i + '-profile-menu'}>
        //                             <FeatherIcon icon={item.icon} className="icon-dual icon-xs ms-1" />
        //                             <span>{item.label}</span>
        //                         </Link>
        //                     </React.Fragment>
        //                 );
        //             })}
        //         </div>
        //     </Dropdown.Menu>
        // </Dropdown>
    );
};

export default ProfileDropdown;
